import axios from '../axios';

class ApiService {
    constructor() {
        this.version = 'v1';
        this.baseEndpoint = '/api';
    }

    // Get full URL with version
    getUrl(endpoint) {
        // Remove leading slash if present
        endpoint = endpoint.replace(/^\//, '');

        // If endpoint already includes version, use as-is
        if (endpoint.startsWith('v')) {
            return `/${endpoint}`;
        }
        console.log(`/${this.version}/${endpoint}`);

        // Otherwise prepend version
        return `/${this.version}/${endpoint}`;
    }

    // HTTP methods with automatic versioning
    async get(endpoint, params = {}) {
        // const url = this.getUrl(endpoint);
        return axios.get(endpoint, { params });
    }

    async post(endpoint, data = {}) {
        const url = this.getUrl(endpoint);
        return axios.post(url, data);
    }

    async put(endpoint, data = {}) {
        const url = this.getUrl(endpoint);
        return axios.put(url, data);
    }

    async patch(endpoint, data = {}) {
        const url = this.getUrl(endpoint);
        return axios.patch(url, data);
    }

    async delete(endpoint) {
        const url = this.getUrl(endpoint);
        return axios.delete(url);
    }

    // Specific resource endpoints
    categories = {
        getAll: () => this.get('categories'),
        getById: (id) => this.get(`categories/${id}`),
        create: (data) => this.post('categories', data),
        update: (id, data) => this.put(`categories/${id}`, data),
        delete: (id) => this.delete(`categories/${id}`)
    };

    businesses = {
        getAll: (params) => this.get('businesses', params),
        getByCategory: (categoryId, params) => this.get(`categories/${categoryId}/businesses`, params),
        getFeatured: () => this.get(`featured-businesses`),
        create: (data) => this.post('businesses', data),
        update: (id, data) => this.put(`businesses/${id}`, data)
    };
}

// Create singleton instance
const apiService = new ApiService();

export default apiService;